export default __webpack_public_path__ + "static/media/kolporter.adc66326.ico";